import { render } from "./PgyRadio.vue?vue&type=template&id=2a282762&scoped=true"
import script from "./PgyRadio.vue?vue&type=script&lang=js"
export * from "./PgyRadio.vue?vue&type=script&lang=js"

import "./PgyRadio.vue?vue&type=style&index=0&id=2a282762&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a282762"]])

export default __exports__